// extracted by mini-css-extract-plugin
export default {"item":"MenuMobileItem_item__+h4uG"};